import React from 'react';
import { Col, Grid, Row } from 'antd';

import ImageC from 'src/components/Image';

type Props = {
	title: string;
	description: string;
	image: string;
	height?: string;
};

const Hero = (props: Props) => {
	const { md, xl } = Grid.useBreakpoint();

	return (
		<div className="bg-white lg:pb-10">
			<div
				className="bg-[url('/images/stem-cell/cell-background.jpg')] bg-cover bg-no-repeat h-[525px] max-xl:h-[350px] max-md:h-[425px] max-xs:h-auto max-xs:min-h-[100px]"
				style={{ height: props.height }}
			>
				<Row>
					<Col xs={24} md={15}>
						<div
							className="xl:pt-6 bg-[url('/images/stem-cell/cell-background.jpg')] bg-cover bg-no-repeat h-[525px] max-xl:h-[350px] max-md:h-[425px] max-xs:h-auto max-xs:min-h-[100px]"
							style={{ height: props.height }}
						>
							<Row>
								<Col md={2} xl={5}></Col>
								<Col xs={24} md={18} xl={17}>
									<div className="container py-6 md:py-12">
										<h1 className="text-primary font-bold text-[38px] max-xl:text-2xl max-xs:text-xl max-xs:font-semibold max-xs:leading-7">
											<span
												dangerouslySetInnerHTML={{
													__html: props.title,
												}}
											/>
										</h1>
										<p className="mt-2 text-[22px] max-xl:text-sm max-xs:mt-4 max-xs:mb-1 max-xs:leading-normal max-xs:text-neutral-5">
											{props.description}
										</p>
									</div>
								</Col>
								<Col md={2}></Col>
							</Row>
						</div>
					</Col>
					{md && (
						<Col xs={24} md={9}>
							<div className="text-right">
								<ImageC
									style={{ objectFit: 'contain' }}
									width={xl ? 630 : md ? 400 : 320}
									height={xl ? 630 : md ? 400 : 320}
									src={props.image}
								/>
							</div>
						</Col>
					)}
				</Row>
			</div>
		</div>
	);
};

export default Hero;

